import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { PostFormRequest } from "../../services/ApiClientService"
import { useTranslation } from "react-i18next"
import { ChangePasswordRequestDto } from "../../Objects/ChangePassword/ChangePasswordRequestDto"
import { ChangeUserPasswordByAdmin } from "../../Objects/ChangePassword/ChangeUserPasswordByAdminDto"

export const useSaveChangePassword = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleSave = async (
    changePasswordDto: ChangePasswordRequestDto | ChangeUserPasswordByAdmin,
    onSuccess: any,
  ) => {
    try {
      enableLoad()

      var response = null

      if (changePasswordDto instanceof ChangePasswordRequestDto) {
        response = await PostFormRequest(API_ROUTES.AUTH.RESET_PASSWORD, changePasswordDto.toJSON())
      } else {
        response = await PostFormRequest(API_ROUTES.AUTH.RESET_PASSWORD_BY_ADMIN, changePasswordDto.toJSON())
      }

      if (response.success) {
        onSuccess && onSuccess()
        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSave,
  }
}
